var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBalls(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 182,
    height: 79,
    viewBox: "0 0 182 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 5.44828,
    cy: 5.44828,
    r: 5.44828,
    fill: "#F2F2F2"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 39.5,
    cy: 5.44828,
    r: 5.44828,
    fill: "#F2F2F2"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 73.5517,
    cy: 5.44828,
    r: 5.44828,
    fill: "#F2F2F2"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 141.655,
    cy: 5.44828,
    r: 5.44828,
    fill: "#F2F2F2"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 175.707,
    cy: 5.44828,
    r: 5.44828,
    fill: "#F2F2F2"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 107.603,
    cy: 5.44828,
    r: 5.44828,
    fill: "#F2F2F2"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 5.44828,
    cy: 39.5,
    r: 5.44828,
    fill: "#F2F2F2"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 39.5,
    cy: 39.5,
    r: 5.44828,
    fill: "#F2F2F2"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 73.5517,
    cy: 39.5,
    r: 5.44828,
    fill: "#F2F2F2"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 141.655,
    cy: 39.5,
    r: 5.44828,
    fill: "#F2F2F2"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 175.707,
    cy: 39.5,
    r: 5.44828,
    fill: "#F2F2F2"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 107.603,
    cy: 39.5,
    r: 5.44828,
    fill: "#F2F2F2"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 5.44828,
    cy: 73.5518,
    r: 5.44828,
    fill: "#F2F2F2"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 39.5,
    cy: 73.5518,
    r: 5.44828,
    fill: "#F2F2F2"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 73.5517,
    cy: 73.5518,
    r: 5.44828,
    fill: "#F2F2F2"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 141.655,
    cy: 73.5518,
    r: 5.44828,
    fill: "#F2F2F2"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 175.707,
    cy: 73.5518,
    r: 5.44828,
    fill: "#F2F2F2"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 107.603,
    cy: 73.5518,
    r: 5.44828,
    fill: "#F2F2F2"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBalls);
export default __webpack_public_path__ + "static/media/Balls.802e52d91fda09bfa5a903a9168a402d.svg";
export { ForwardRef as ReactComponent };